import { usePolkadot } from '@/shared/hooks/usePolkadot';
import { useStateChainAccount } from './useStateChainAccount';
import useStore from './useStore';

/**
 * with evm onboarding, we need to read refund addresses from the zustand store
 * because we cannot set them on chain until the account is onboarded
 *
 * after onboarding, or for regular state chain accounts, we can just read them
 * from the account data
 */
export default function useRefundAddresses() {
  const { selectedAccount } = usePolkadot();
  const { account } = useStateChainAccount();
  const storeRefundAddresses = useStore((state) => state.refundAddresses);

  if (account) return account.refund_addresses ?? null;

  if (selectedAccount?.type === 'evm') return storeRefundAddresses;

  return null;
}
